if (!customElements.get('dd-recipe-checklist')) {
  customElements.define(
    'dd-recipe-checklist',
    class DDRecipeChecklist extends HTMLElement {
      connectedCallback() {
        this.onReady = () => this.enhance();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onReady, { once: true });
        } else {
          this.enhance();
        }
      }

      enhance() {
        this.querySelectorAll('li').forEach((item) => {
          if (!item.textContent.trim() || item.querySelector('input, label, ul, ol, p, div, table, blockquote')) return;
          const label = document.createElement('label');
          const checkbox = document.createElement('input');
          const text = document.createElement('span');
          label.className = 'dd-recipe-checklist__label';
          checkbox.type = 'checkbox';
          checkbox.className = 'dd-recipe-checklist__input';
          checkbox.autocomplete = 'off';
          text.className = 'dd-recipe-checklist__text';
          while (item.firstChild) text.append(item.firstChild);
          label.append(checkbox, text);
          item.append(label);
          item.classList.add('dd-recipe-checklist__item');
          item.parentElement.classList.add('dd-recipe-checklist__list');
        });
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onReady);
      }
    },
  );
}

if (!customElements.get('dd-recipe-print')) {
  customElements.define(
    'dd-recipe-print',
    class DDRecipePrint extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-dd-recipe-print]');
        if (!this.button) return;

        this.handleClick = () => {
          const section = this.closest('.shopify-section');
          const readingLayout = section?.querySelector('.dd-recipe-article__panel--reading');
          const closedTips = readingLayout ? [...section.querySelectorAll('.dd-recipe-faq details:not([open])')] : [];
          closedTips.forEach((details) => { details.open = true; });

          document.body.classList.add('dd-recipe-printing');
          section?.classList.add('dd-recipe-print-target');

          const cleanup = () => {
            document.body.classList.remove('dd-recipe-printing');
            section?.classList.remove('dd-recipe-print-target');
            closedTips.forEach((details) => { details.open = false; });
          };

          window.addEventListener('afterprint', cleanup, { once: true });
          window.requestAnimationFrame(() => window.print());
        };

        this.button.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.handleClick);
      }
    },
  );
}
